import React from 'react';
import Header from '../components/Header';
import Footer from '../components/Footer';

const PoliticaPrivacidad = () => {
  return (
    <div className="bg-white min-h-screen">
      <Header />
      <main className="pt-28 pb-16">
        <div className="container mx-auto px-6 lg:px-10 max-w-4xl">
          <h1 className="text-3xl md:text-4xl font-bold text-gray-900 mb-8">
            Información sobre Protección de Datos
          </h1>

          <div className="prose prose-lg max-w-none text-gray-700 space-y-6">
            <section>
              <h2 className="text-xl font-semibold text-gray-900 mt-8 mb-4">1. Datos relativos al Responsable</h2>
              <p><strong>Responsable del Tratamiento</strong></p>
              <ul className="list-none pl-0 space-y-1">
                <li><strong>Entidad:</strong> TALLERES MICROBAT, SL</li>
                <li><strong>CIF:</strong> B31701071</li>
                <li><strong>Dirección:</strong> Polígono Industrial de Egüés, C/Z, Nº16 - 31486 Egüés (Navarra)</li>
                <li><strong>Email:</strong> <a href="mailto:microbat@microbat.es" className="text-[#0d3b66] hover:underline">microbat@microbat.es</a></li>
                <li><strong>Responsable del tratamiento:</strong> Iñaki Aristu Mugueta</li>
                <li><strong>Teléfono:</strong> 948 361 146</li>
              </ul>
            </section>

            <section>
              <h2 className="text-xl font-semibold text-gray-900 mt-8 mb-4">2. Finalidades</h2>
              <p>
                En cumplimiento de lo dispuesto en el Reglamento Europeo 2016/679 General de Protección de Datos y la Ley Orgánica 3/2018 de Protección de Datos Personales y Garantía de Derechos Digitales, le informamos de que, dependiendo de la relación que tenga con nosotros, en <strong>TALLERES MICROBAT, SL</strong> tratamos los datos que nos facilita para alguna, o todas, las siguientes finalidades:
              </p>
              <ul className="list-disc pl-6 space-y-1">
                <li>Consulta online</li>
                <li>Información procedente de Cookies</li>
                <li>Tramitación de presupuestos</li>
              </ul>
            </section>

            <section>
              <h2 className="text-xl font-semibold text-gray-900 mt-8 mb-4">3. Plazo de conservación de los datos</h2>
              <p>
                Sus datos serán conservados por un plazo de 5 años. En el caso que requiera su eliminación de forma anticipada, solicítelo mediante el ejercicio del derecho de supresión.
              </p>
              <p>
                Asimismo, los datos que por motivos legales deban ser almacenados durante un tiempo necesario para cumplir normas específicas, serán bloqueados y únicamente estarán a disposición de la autoridad pública correspondiente.
              </p>
            </section>

            <section>
              <h2 className="text-xl font-semibold text-gray-900 mt-8 mb-4">4. Legitimación</h2>
              <p>La base legal para el tratamiento de sus datos radica por:</p>
              <ul className="list-disc pl-6 space-y-1">
                <li>Consentimiento inequívoco</li>
              </ul>
            </section>

            <section>
              <h2 className="text-xl font-semibold text-gray-900 mt-8 mb-4">5. Destinatarios</h2>
              <p>Sus datos personales serán comunicados a terceros en los siguientes supuestos:</p>
              <ul className="list-disc pl-6 space-y-1">
                <li>Administración tributaria</li>
                <li>Bancos y entidades financieras</li>
                <li>Entidades de Consultoría/Auditoría</li>
                <li>Entidades informáticas de mantenimiento de software y hardware</li>
                <li>Gestoría/Asesoría</li>
                <li>Seguridad social</li>
              </ul>
            </section>

            <section>
              <h2 className="text-xl font-semibold text-gray-900 mt-8 mb-4">6. Derechos</h2>
              <p>
                Tiene derecho a obtener confirmación sobre si en <strong>TALLERES MICROBAT, SL</strong> estamos tratando datos personales que le conciernan, o no.
              </p>
              <p>
                Asimismo, tiene derecho de acceso a sus datos personales, así como a solicitar la <em>rectificación</em> de los datos inexactos o, en su caso, solicitar su <em>supresión</em> cuando, entre otros motivos, los datos ya no sean necesarios para los fines que fueron recogidos.
              </p>
              <p>
                En determinadas circunstancias, podrá solicitar la <em>limitación del tratamiento</em> de sus datos, en cuyo caso únicamente los conservaremos para el ejercicio o la defensa de reclamaciones.
              </p>
              <p>
                Adicionalmente, en determinadas circunstancias y por motivos relacionados con su situación particular, podrá ejercer el derecho de <em>oposición</em> al tratamiento de sus datos. <strong>TALLERES MICROBAT, SL</strong> dejará de tratar los datos, salvo por motivos legítimos imperiosos, o el ejercicio o la defensa de posibles reclamaciones.
              </p>
              <p>
                Asimismo, puede ejercer el derecho a la <em>portabilidad</em> de los datos, así como retirar los consentimientos facilitados en cualquier momento, sin que ello afecte a la licitud del tratamiento basado en el consentimiento previo a su retirada.
              </p>
              <p>
                Si desea hacer uso de cualquiera de sus derechos puede dirigirse a nosotros mediante correo postal a la siguiente dirección: <strong>Polígono Industrial de Egüés, C/Z, Nº16 - 31486 Egüés (Navarra)</strong> adjuntando una fotocopia del DNI, para la certeza de su identidad. Recuerde facilitar la mayor información posible sobre su solicitud: Nombre y apellidos, dirección de correo electrónico que utiliza para la cuenta o portal objeto de su solicitud.
              </p>
              <p>
                Por último, le informamos que puede dirigirse ante la Agencia Española de Protección de Datos y demás organismos públicos competentes para cualquier reclamación derivada del tratamiento de sus datos personales.
              </p>
            </section>
          </div>
        </div>
      </main>
      <Footer />
    </div>
  );
};

export default PoliticaPrivacidad;
